/**
 * Thermo King Alarm Detail Formatter.
 * @param {*} value
 * @param {*} row
 * @returns {*}
 */
window.thermoKingAlarmDetailFormatter = function(value, row) {
    let html = "";
    if (row.recommendation) {
        html += '<div class="form-group">';
        html += "<label>" + __("Recommendation:") + "</label>";
        html += '<textarea class="form-control" rows="3">' + row.recommendation + "</textarea>";
        html += "</div>";
    }
    return html;
};
